<template>
  <header class="w-full bg-black fixed top-0 z-10">
    <div
      class="container mx-auto h-full flex flex-col md:flex-row justify-between"
    >
      <div class="flex justify-center">
        <router-link to="/">
          <img class="logo h-full" :src="originalLogo" style="height: 80px" />
        </router-link>
        <div class="absolute md:hidden right-0 mr-4 mt-6">
          <eva-icon
            class="fill-current text-primary-color"
            name="menu-outline"
            height="30"
            width="30"
            @click="isCollapsed = !isCollapsed"
          />
        </div>
      </div>
      <ul
        class="menu-items"
        v-bind:class="{
          collapsed: isCollapsed,
        }"
      >
        <li class="px-8 py-2 md:py-0 text-lg">
          <router-link to="/">Home</router-link>
        </li>
        <li class="px-8 py-2 md:py-0 text-lg">
          <router-link to="/properties">Properties</router-link>
        </li>
        <li class="px-8 py-2 md:py-0 text-lg">
          <router-link to="/about-us">About Us</router-link>
        </li>
        <li class="px-8 py-2 md:py-0 text-lg">
          <router-link to="/contact-us">Contact Us</router-link>
        </li>
        <li class="px-8 py-2 md:py-0 text-lg">
          <router-link to="/we-speak-german">Wir sprechen Deutsch!</router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isCollapsed: true,
      originalLogo: require("@/assets/original-logo.svg"),
    };
  },
};
</script>

<style scoped lang="scss">
header {
  height: 80px;
}

.menu-items {
  @apply text-white
          flex flex-col
          m-0
          items-center
          bg-black
          w-full
          absolute
          p-4;
  top: 80px;

  &.collapsed {
    @apply hidden;
  }

  @screen md {
    @apply p-0 relative w-auto flex-row;
    top: 0px;

    &.collapsed {
      @apply flex;
    }
  }
}
</style>